import React from 'react'

export const Lines = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path d="M8.7602 8.82963V4.93963H7.4402V8.82963L6.0902 7.61963L5.2002 8.61963C7.7102 10.8796 7.8202 10.8796 8.1102 10.8796C8.4002 10.8796 8.5002 10.8796 11.0002 8.62963L10.1102 7.62963L8.7602 8.82963Z" fill="white" />
      <path d="M4.7602 3.04963V6.93963H3.4402V3.04963L2.0902 4.25963L1.2002 3.25963C3.7102 0.999634 3.8202 0.999634 4.1102 0.999634C4.4002 0.999634 4.5002 0.999634 7.0002 3.24963L6.1102 4.24963L4.7602 3.04963Z" fill="white" />
    </svg>
  )
}
